import {BottomNavbar} from "../BottomNavbar";

export const MeasureNavbar = ({
  selectedTab,
  onClickLeftButton = () => null,
  onClickMiddleButton = () => null,
  onClickRightButton = () => null,
}) => {
  const buttons = [
    {
      label: '測量',
      name: 'input',
      icon: 'fa-keyboard',
      onClick: onClickLeftButton,
    },
    {
      label: '數據',
      name: 'visualization',
      icon: 'fa-chart-simple',
      onClick: onClickMiddleButton,
    },
    {
      label: '個人資料',
      name: 'profile',
      icon: 'fa-user',
      onClick: onClickRightButton,
    }
  ]
  return (
    <BottomNavbar
      lightShadow
      buttons={buttons}
      selectedTab={selectedTab}
    />
  )
}
